import { Button, Divider, Flex, Modal, Text } from '@cmpsr/components';
import { Intervention } from '../../../types';
import ActionPlanBadge from '../../common/action-plan-badge';
import { formatRiskRound, getInterventionHighestRisk } from '@/utils';

type ModalRemoveActiveInterventionsProps = {
  interventions: Intervention[];
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
};

export default function ModalRemoveActiveInterventions({
  isOpen,
  interventions,
  onClose,
  onRemove,
}: ModalRemoveActiveInterventionsProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <Modal.Overlay bg="background-overlay" backdropFilter="auto" />
      <Modal.Content
        bg="background-page"
        borderRadius="radii-2"
        p={{ base: 'spacer-5', lg: 'spacer-10' }}
        maxW={{ base: 'full', md: '654px' }}
        mx="spacer-4"
      >
        <Modal.Header display="grid" w="full" bg="background-page" p={0}>
          <Text variant="text-header-S" textAlign="center">
            You are
            <Text as="span" textStyle="text-header-s-v" px="spacer-2">
              removing
            </Text>
            the following items:
          </Text>
        </Modal.Header>
        <Modal.Body display="flex" flexDirection="column" alignItems="center" gap={2} backgroundColor="background-page">
          <Divider />
          {interventions.map((intervention) => {
            const { title, riskImpact, id } = intervention;
            const { reducedRisk } = getInterventionHighestRisk(riskImpact);

            return (
              <Flex key={id} direction="column" alignItems={{ md: 'center' }}>
                <Text variant="text-body-display-XS">{title}</Text>
                <Flex alignItems={{ md: 'center' }} direction="row" gap={2}>
                  <Text variant="text-body-regular" color="text-secondary">
                    Reduce {reducedRisk?.cancerType} risk by
                  </Text>
                  <ActionPlanBadge text={`${formatRiskRound(reducedRisk.impact)}`} />
                </Flex>
              </Flex>
            );
          })}
          <Divider />
        </Modal.Body>
        <Modal.Footer display="flex" flexDirection="column" p={0} background="background-page">
          <Text pb="spacer-4" variant="text-body-large-regular" textAlign="center">
            Are you sure you want to remove these and update your Action Plan? You will be able to add them back at any
            other time
          </Text>
          <Flex flexDirection={{ base: 'column-reverse', lg: 'row' }} gap="spacer-4" w="full">
            <Button variant="primary-alt" size="l" w="full" onClick={onClose}>
              Cancel
            </Button>
            <Button size="l" w="full" onClick={onRemove}>
              Update Action Plan
            </Button>
          </Flex>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
